import React from 'react';
import TotalUnits from '../TotalUnits'; 
import UnitsTableHeaderItem from './UnitsTableHeaderItem'; 
import UnitsTableItem from './UnitsTableItem'; 
import * as S from './UnitsTable.style';

export default function UnitsTable ({ data, color, tableItems }) {
  const totalItems = data.reduce((arr, { actualQuantity }) => arr + Number(actualQuantity), 0)

  return (
    <>
      <S.UnitsTable gridUnits={tableItems.length}>
        { tableItems.map((info) => <UnitsTableHeaderItem { ...info } color={color} />) }
        { data.map((item) => tableItems.map((info) => <UnitsTableItem {...info} { ...item } />)) }
      </S.UnitsTable>
      <TotalUnits value={totalItems} color={color} />
    </>
  )
}